
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 718","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-rule":"evenodd","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M452.1.2c-30.3 0-55.3 25-55.3 55.3v16H115.1v-16c0-30.3-25-55.3-55.3-55.3S4.5 25.2 4.5 55.5V661.6c0 30.3 25 55.3 55.3 55.3s55.3-25 55.3-55.3v-17.8h281.7v17.8c0 30.3 25 55.3 55.3 55.3s55.3-25 55.3-55.3V55.5c0-30.3-24.9-55.3-55.3-55.3zm-16 55.3c0-8.9 7.1-16 16-16s16 7.1 16 16v16h-32zm-392.3 0c0-8.9 7.1-16 16-16s16 7.1 16 16v16h-32zM76 661.8c-.1 8.9-7.2 16-16.1 16s-16-7.1-16-16V644H76zm-32.2-58.9V110.8h424.4v492.1zm424.5 58.9h-.1c0 8.9-7.1 16-16 16s-16-7.1-16-16V644h32.1z"}}),_c('path',{attrs:{"d":"M102.7 554.8h306.7c5.3 0 8.9-3.6 8.9-8.9V169.6c0-5.4-3.6-8.9-7.1-8.9H102.7c-5.3 0-8.9 3.6-8.9 8.9v376.2c-.1 5.4 3.5 9 8.9 9zm244.2-354.9H379v49.9h-32.1zm0 89.2H379V339h-32.1zm0 89.1H379v49.9h-32.1zm0 89.2H379v46.4h-32.1zM204.3 199.9h103.4v313.8H204.3zm-71.3 0h32.1v49.9H133zm0 89.2h32.1V339H133zm0 89.1h32.1v49.9H133zm0 89.2h32.1v46.4H133z"}})])])
          )
        }
      }
    